module.exports = __webpack_public_path__ + "img/ico-file-chart.75d4aeac.svg";